import { useEffect } from 'react';
import { useMediaClient } from './MediaClientProvider';
import { useMediaStore } from './useMediaStore';
export function useFileState(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var collectionName = options.collectionName,
    occurrenceKey = options.occurrenceKey,
    _options$skipRemote = options.skipRemote,
    skipRemote = _options$skipRemote === void 0 ? false : _options$skipRemote,
    includeHashForDuplicateFiles = options.includeHashForDuplicateFiles;
  var mediaClient = useMediaClient();
  var fileState = useMediaStore(function (state) {
    return state.files[id];
  });
  useEffect(function () {
    // No need to resubscribe if there is a fileState already
    if (!fileState && !skipRemote) {
      mediaClient.file.getFileState(id, {
        collectionName: collectionName,
        occurrenceKey: occurrenceKey,
        includeHashForDuplicateFiles: includeHashForDuplicateFiles
      });
    }
  }, [id, mediaClient, collectionName, occurrenceKey, skipRemote, fileState, includeHashForDuplicateFiles]);
  return {
    fileState: fileState
  };
}